module.exports = __webpack_public_path__ + "static/media/scroll3_5_0.a7232dcc.png";